import Alert from './alert';
import MapMenu from './map_menu';
import BookmarksView from '../views/bookmarks_view';

const Bookmarks = {
	/**
	 * Get all bookmarks
	 */
	all: function () {
		const localBookmarks = localStorage.getItem('bookmarks');
		let out = {};

		try {
			const parsed = JSON.parse(localBookmarks);
			if (parsed['bookmarks']) {
				out = parsed['bookmarks'];
			}
		} catch (e) {
			out = {};
		}
		return out;
	},

	/**
	 * Re-save the bookmarks
	 */
	save: function (bookmarks) {
		localStorage.setItem('bookmarks', JSON.stringify({ bookmarks: bookmarks }));
	},

	/**
	 * Add a bookmark
	 */
	add: function (key, value) {
		let bookmarks = this.all();
		bookmarks[key] = value;
		this.save(bookmarks);
	},

	/**
	 * Remove a bookmark
	 */
	remove: function (key) {
		let bookmarks = this.all();
		if (bookmarks[key]) {
			delete bookmarks[key];
			this.save(bookmarks);
		}
	},

	clear: function () {
		this.save({});
	},

	any: function () {
		return Object.keys(this.all()).length > 0;
	},

	/**
	 * See if a key id is bookmarked
	 */
	has: function (key) {
		return Object.keys(this.all()).includes(key);
	},

	/**
	 * Toggle
	 * Returns a boolean represeting whether the obj is bookmarked
	 * after the toggle.
	 */
	toggle: function (key, title) {
		if (this.has(key)) {
			this.remove(key);
			return false;
		}
		this.add(key, title);
		return true;
	},

	/**
	 * Fills in .bookmark-button-container divs
	 * with a bookmark button
	 */
	buildButtons: () => {
		const buttonContainer = document.querySelector('.bookmark-button-container');
		const key = buttonContainer.dataset.bookmarkKey;
		const title = buttonContainer.dataset.bookmarkTitle;
		const active = Bookmarks.has(key) ? true : false;
		const remove_msg = 'Remove from your saved places';
		const add_msg = 'Add to your saved places';
		const button = buttonContainer.querySelector('button');

		button.classList.add(active ? 'bookmark-on' : 'bookmark-off');
		button.setAttribute('title', active ? remove_msg : add_msg);

		// Handle the click toggle
		button.addEventListener('click', () => {
			if (Bookmarks.toggle(key, title)) {
				button.setAttribute('title', remove_msg);
				button.classList.toggle('bookmark-on');
				button.classList.toggle('bookmark-off');
				button.querySelector('span.uw-sr-only').innerHTML = remove_msg;
				new Alert('Added to my places', {
					delay: 3000,
				});
			} else {
				button.setAttribute('title', add_msg);
				button.classList.toggle('bookmark-on');
				button.classList.toggle('bookmark-off');
				button.querySelector('span.uw-sr-only').innerHTML = add_msg;
				new Alert('Removed from my places', {
					delay: 3000,
				});
			}
		});
	},

	addListeners: () => {
		const bookmarksEl = document.getElementById('bookmarks');
		if (!bookmarksEl) return;
		bookmarksEl.addEventListener('click', () => {
			const bookmarks_view = new BookmarksView();
			bookmarks_view.load();
			MapMenu.hide();
		});
	},
};

Bookmarks.addListeners();

export default Bookmarks;
